import { createSlice } from "@reduxjs/toolkit";

const bankSlice = createSlice({
    name:'bank',
    initialState:{
        bank:[]
    },
    reducers: {
        addBank : (state,action) => {
            state.bank = [...state.bank,action.payload]
        },
       
    }
});

export const { addBank } = bankSlice.actions;
export default bankSlice.reducer;